export default __webpack_public_path__ + "static/mobile_section4_feature1-8c38fe1eeb0336bada17138d75238d35.png";